window.addEventListener("load", () => {
    const boldElement = document.querySelector(".bold_option.bold_option_swatch .bold_option_element");
    const imgEl = document.createElement("img");
    imgEl.className = "custom-img";
    boldElement.appendChild(imgEl);
    const observer = new MutationObserver(() => {
        observer.disconnect();
        const selectedSwatch = document.querySelector(".bold_option_value_element.bold_swatch_selected");
        if (selectedSwatch) {
            const imgSrc = selectedSwatch.nextSibling.nextSibling.querySelector("img").src;
            imgEl.src = imgSrc;
        } else {
            imgEl.src = "";
        }
        observer.observe(boldElement, { childList: true, subtree: true, attributes: true });
    });
    observer.observe(boldElement, { childList: true, subtree: true, attributes: true });
});